import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Cookies from 'universal-cookie';

import Header from './Header/Header';
import RequestModules from './request-modules';
import AuthModal from '../base/login';
import Notify from '../common/notify';
import { TRootState } from '../../reducers';

import { toggleOptionCard, toggleModal } from '../../actions/ViewController';

import history from '../../history';

const cookies = new Cookies();

type TClientLandingProps = {
    loggedIn: boolean;
    rolePopout: {
        roleExtras: boolean;
        shiftTimes: boolean;
    };
    showModal: string;
    signedUp: boolean;
    toggleOptionCard: (card?: string) => void;
    toggleModal: (modal: string, type: string) => void;
}

class ClientLanding extends Component<TClientLandingProps> {
    // eslint-disable-next-line react/sort-comp
    notificator: InstanceType<typeof Notify> | null = null;

    constructor(props: TClientLandingProps) {
        super(props);
        this.handleClickOverlay = this.handleClickOverlay.bind(this);
    }

    handleClickOverlay() {
        this.props.toggleOptionCard();
    }

    redirectToDashboard() {
        history.push('/operations/notifications');
    }

    componentDidMount() {
        const currentUrlParams = new URLSearchParams(history.location.search);

        if (this.props.loggedIn) {
            this.redirectToDashboard();
        }
        if (this.props.showModal) {
            this.props.toggleModal('authModal', this.props.showModal);
        }
        if (currentUrlParams.get('agency')) {
            const expiry = new Date(
                new Date().getTime() + (420 * 60 * 1000 * 24),
            );
            cookies.set('agency', currentUrlParams.get('agency'), {
                path: '/',
                expires: expiry,
            });
        }
        if (currentUrlParams.get('ref')) {
            const expires = new Date(
                new Date().getTime() + (1000 * 60 * 60 * 24),
            );
            cookies.set('ref', currentUrlParams.get('ref'), {
                path: '/',
                expires,
            });
        }

        const autoLoginError = (history.location.state as { autoLoginError?: string } | undefined)
            ?.autoLoginError;
        if (autoLoginError) {
            // Defer so the Notify ref is definitely mounted.
            setTimeout(() => {
                this.notificator?.error('Login failed', autoLoginError, 8000);
            }, 0);
            history.replace({
                pathname: history.location.pathname,
                search: history.location.search,
                state: {},
            });
        }
    }

    render() {
        const { roleExtras, shiftTimes } = this.props.rolePopout;

        return (
            <div className="client-landing">
                <Notify ref={ref => { this.notificator = ref; }} />
                <Header />
                <div className="page page--client-landing">
                    <RequestModules />
                    {roleExtras || shiftTimes ? (
                        <div
                            className="overlay-full"
                            onClick={this.handleClickOverlay}
                        />
                    ) : false}
                </div>
                <AuthModal />
            </div>
        );
    }
}

function mapStateToProps(state: TRootState) {
    return {
        rolePopout: state.view.rolePopout,
        loggedIn: state.clientData.loggedIn,
        signedUp: state.clientData.signedUp,
    };
}

export default withRouter(
    // @ts-ignore
    connect(mapStateToProps, { toggleOptionCard, toggleModal })(ClientLanding),
);
